import React from 'react';

interface ServiceItem {
  title: string;
  description: string;
  imageUrl: string;
}

const servicesData: ServiceItem[] = [
  {
    imageUrl: 'Matt Image111.jpg',
    title: 'Innovative Workstations',
    description: 'Designed to inspire productivity and creativity.'
  },
  {
    imageUrl: 'team7.jpg',
    title: 'Creative Corners',
    description: 'Bright and colorful areas to fuel innovative ideas.'
  },
  {
    imageUrl: 'md1.jpg',
    title: 'Collaborative Spaces',
    description: 'Modern areas for teamwork and brainstorming sessions.'
  },
  {
    imageUrl: 'md3.jpg',
    title: 'Relaxation Zones',
    description: 'Comfortable spaces to recharge and stay motivated.'
  },
  {
    imageUrl: 'team8.jpg',
    title: 'Executive Offices',
    description: 'Stylish and private workspaces for focused leadership.'
  },
  {
    imageUrl: 'team5.jpg',
    title: 'Quiet Zones',
    description: 'Dedicated areas for focused work without interruptions.'
  }
];

const OurWorkspace: React.FC = () => {
  return (
    <div className="w-full min-h-screen bg-[#f3f4f6] p-4 sm:p-6 lg:p-8">
      <div className="text-center mb-12">
        <h1 className="text-xl sm:text-2xl font-bold text-blue-950">
          Discover{" "}
          <span
            style={{
              background:
                "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
              padding: "0px 5px",
            }}
          >
            Our Creative
          </span>
          Workspace
        </h1>
        <p className="text-base text-gray-600">
          Explore our vibrant office gallery, designed to inspire creativity and innovation.
        </p>
      </div>

      {/* Mobile Grid View */}
      <div className="block md:hidden">
        <div className="grid grid-cols-2 gap-2">
          {servicesData.map((service, index) => (
            <div key={index} className="group relative h-40 rounded-lg overflow-hidden cursor-pointer">
              <img
                src={service.imageUrl}
                alt={service.title}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/0 transition-opacity duration-300 opacity-0 group-hover:opacity-100">
                <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-full transition-transform duration-300 group-hover:translate-y-0">
                  <h3 className="text-white text-sm font-semibold mb-1">
                    {service.title}
                  </h3>
                  <p className="text-white/90 text-xs">
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Desktop/Tablet Grid View */}
      <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {servicesData.map((service, index) => (
          <div key={index} className="group relative h-64 rounded-lg overflow-hidden cursor-pointer">
            <img
              src={service.imageUrl}
              alt={service.title}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/0 transition-opacity duration-300 opacity-0 group-hover:opacity-100">
              <div className="absolute bottom-0 left-0 right-0 p-4 transform translate-y-full transition-transform duration-300 group-hover:translate-y-0">
                <h3 className="text-white text-xl font-semibold mb-2">
                  {service.title}
                </h3>
                <p className="text-white/90 text-sm mb-4">
                  {service.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurWorkspace;